import { useQuery } from "react-query";
import { mutateErrors } from "../../../utils";
import { parsePrivateClassToFrontEndModel } from "../helpers/parsePrivateClassToFrontEndModel";
import { usePrivateClassConfig } from "../modals/hooks/usePrivateClassConfig";
import { QUERY_KEYS } from "../../../constants";
import { useUserId } from "../../user/hooks/useUserId";
import usePrivateClassQueries from "./usePrivateClassQueries";

export const usePrivateClassPage = () => {
  const privateClassWizardConfigs = usePrivateClassConfig();
  const { getPrivateClassList } = usePrivateClassQueries();
  const teacherId = useUserId();
  const { privateClassListForTeacher: privateClassListByProvider } = QUERY_KEYS;

  const { isLoading, isError, error, data, refetch } = useQuery(
    [privateClassListByProvider, teacherId],
    async () => {
      const response = await getPrivateClassList({ teacherId });
      return parsePrivateClassToFrontEndModel(response.data);
    },
  );

  let errorMessage;
  if (isError) {
    const { message } = mutateErrors(error);
    errorMessage = message;
  }

  return {
    isError,
    privateClasses: data,
    isLoading,
    errorMessage,
    privateClassWizardConfigs,
    refetchPrivateClasses: refetch,
  };
};
